





























































































































































import Vue, { PropType } from "vue";
import { Table, TableColumn, Select, Option } from "element-ui";
import Receiver from "../../../../types/receivers/Receiver";
import { ValidationObserver } from "vee-validate";
import { DefaultComputed, DefaultProps } from "vue/types/options";

type Methods = {
  validateAndUpdateReceiverForm(): Promise<boolean>;
  emitReceiverFormChangedEvent(): void;
};

export default Vue.extend<any, Methods, DefaultComputed, DefaultProps>({
  props: {
    receiver: {
      required: true,
      type: Object as PropType<Receiver>,
    },
  },
  components: {
    [Table.name]: Table,
    [Option.name]: Option,
    [Select.name]: Select,
    [TableColumn.name]: TableColumn,
  },
  data() {
    return {
      receiverForm: {
        id: this.receiver.id,
        companyName: this.receiver.companyName,
        contactName: this.receiver.contactName,
        contactEmail: this.receiver.contactEmail,
        contactPhone: this.receiver.contactPhone,
        registrationNumber: this.receiver.registrationNumber,
      } as Receiver,
    };
  },
  computed: {
    getInvoiceData(): Receiver {
      return this.receiver;
    },
  },
  created() {
    this.$watch(
      "receiver",
      (receiver: Receiver) => {
        this.receiverForm.id = receiver.id;
        this.receiverForm.companyName = receiver.companyName;
        this.receiverForm.contactName = receiver.contactName;
        this.receiverForm.contactEmail = receiver.contactEmail;
        this.receiverForm.contactPhone = receiver.contactPhone;
        this.receiverForm.registrationNumber = receiver.registrationNumber;
      },
      { immediate: true }
    );
  },
  methods: {
    emitReceiverFormChangedEvent(): void {
      this.$emit("receiver-general-data-form-dirty");
    },
    async validateAndUpdateReceiverForm(): Promise<boolean> {
      const validated = await (
        this.$refs.receiverForm as InstanceType<typeof ValidationObserver>
      ).validate();
      if (!validated) {
        return false;
      }

      this.$emit("receiver-general-data-updated", this.receiverForm);
      return true;
    },
  },
});
